<template>
	<WaitDialog :isActive="isWaiting" title="What are you waiting for?" />
	<GhostDraftView :dataCaptureArgs="dataCaptureArgs" />
</template>

<script lang="ts">
import { nextTick, onMounted, ref } from 'vue';
import WaitDialog from '@/components/WaitDialog.vue';
import GhostDraftView from '@/components/GhostDraftView.vue';
import * as GhostDraftDataCapture from '@/assets/GhostDraftDataCapture-3.0';

export default {
	name: 'GhostDraftDataCapturePOC',
	route: {
		path: '/ghost-dc-preview',
		meta: {
			requiresAuth: true,
			title: 'GhostDraft Data Capture POC'
		}
	},
	components: {
		WaitDialog,
		GhostDraftView,
	},
	setup() {
		const isWaiting = ref(false);

		// Example IDataCaptureArguments object
		const dataCaptureArgs: GhostDraftDataCapture.IDataCaptureArguments = {
			template: "CA 25 51 10 13 Exclusion - Designated Products",
			documentService: 'ITDevelopment',
			packageName: 'ISO Commercial Auto Project',
			packageVersion: '2410.0',
			company: 'moedev',
		};

		return {
			isWaiting,
			dataCaptureArgs,
		};
	},
};
</script>